import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";

/**
 * Component to render BusinessMan component for eligibility tab
 */
const BusinessMan = (): React.ReactElement => {
  return (
    <div className="bg-gray-150" data-testid="businessman-component">
      <AccordionV2
        testId="businessman-of-the-year"
        className="border-none py-4"
        headerChildren={
          <EventsAwardsAccordionHeader title="Businessman of the Year" />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mt-4 px-6 py-4">
          <p>
            The criteria for the Businessman of the Year Award are categorised
            into four areas:
          </p>

          <p>
            <strong>Financial Performance</strong>
          </p>

          <p>
            He/She must have made an outstanding and sustained contribution to
            his or her organisation. In the case of a public company, for
            instance, he/she must have contributed to an improvement to the
            returns on shareholders&apos; funds, and sales, in the light of
            conditions prevailing at the time. Consideration will also be given
            to the standard of corporate disclosure of the awardee&apos;s
            company.
          </p>

          <p>
            In the case of a private company or sole proprietorship, etc he/she
            must have contributed to an improvement on return on capital
            invested. Reducing a company&apos;s losses is also considered an
            achievement. This would be regarded as a contribution to the
            stability of the organisation.
          </p>

          <p>
            <strong>Personal Qualities</strong>
          </p>

          <ul className="list-outside list-disc pb-6 pl-8">
            <li>
              <strong>Integrity:</strong> The awardee&apos;s integrity should be
              of the highest standard
            </li>
            <li>
              <strong>Entrepreneurial abilities:</strong>
              <br />
              Personal contribution to an organisation outside the realm of
              his/her immediate business interests. It is a merit point for the
              awardee if he/she has made such a contribution
            </li>
          </ul>

          <p>
            <strong>Managerial Skills</strong>
          </p>

          <ul className="list-outside list-disc pb-6 pl-8">
            <li>
              <strong>Depth of Management:</strong> The awardee should have
              contributed to the raising of management skills and the
              establishment of a viable organisational structure.
            </li>
            <li>
              <strong>Adaptability:</strong> The awardee must have adapted to
              the changing environment and demands.
            </li>
            <li>
              <strong>Tenacity:</strong> The awardee should have displayed
              perseverance and tenacity in working towards objectives.
            </li>
            <li>
              <strong>Leadership Qualities:</strong> The awardee must be someone
              who has won the respect of his/her subordinates and whose actions
              set an example for his/her organisation. He/she should be adept at
              motivating employees.
            </li>
            <li>
              <strong>Productivity:</strong> The awardee must have made a
              substantial contribution to improving the output of his/her
              employees.
            </li>
            <li>
              <strong>Creativity:</strong> The awardee should have an innovative
              approach to his/her business affairs.
            </li>
            <li>
              <strong>Good Labour Management:</strong> The awardee should have a
              track record of establishing and maintaining harmonious relations
              in the organisation.
            </li>
          </ul>

          <p>
            <strong>Contribution to Singapore&apos;s Development</strong>
          </p>

          <p>
            The awardee or his/her organisation should have made a positive
            contribution to Singapore&apos;s development. This includes
            contributions in the economic, social and cultural areas.
          </p>

          <p>
            <strong>Rules of Eligibility</strong>
          </p>

          <ul className="list-outside list-disc pb-6 pl-8">
            <li>The awardee should be involved in a business enterprise</li>
            <li>
              He/she should be a Singapore citizen and living in Singapore
            </li>
            <li>There is no restriction on sex, age, or race</li>
          </ul>
        </div>
      </AccordionV2>
    </div>
  );
};

export default BusinessMan;
